<template>
  <div>
    <el-row :gutter="20" v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_edit') === -1 ">

      <el-col :span="4">
        <el-input placeholder="标题" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button>        </el-input>
      </el-col>
      <el-col :span="4">

      </el-col>
    </el-row>
    <div>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button-group>
            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="add()">新增合约厂家</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table
        :data="dataList"
        style="width: 100%" v-loading="loadingList">
        <el-table-column
          prop="manufactor_name"
          label="厂家"
          width=""
          >
        </el-table-column>
        <el-table-column
          prop="title"
          label="厂家标题"
          width=""
          >
        </el-table-column>
        <el-table-column
          prop="long_title"
          label="合约标题"
          width="">
        </el-table-column>

        <el-table-column prop="item_bn" label="绑定虚拟商品" width="160" >
            <template slot-scope="scope">
                <el-button type="text" @click="handleDialogGoods(scope.row.bind_goods)">查看商品</el-button>
            </template>
        </el-table-column>
        <el-table-column
          label="活动时间"
          width="">
          <template slot-scope="scope">
            {{scope.row.long_begin_time}}-{{scope.row.long_end_time}}
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="">
          <template slot-scope="scope">
            <el-button type="text" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
    <el-dialog title="添加、编辑厂家合约" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
       <template>

         <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
           <el-form-item label="选择厂家" >
             <el-select
                 v-model="form.manufactor"
                 placeholder="请输入关键词"
                 :remote-method="remoteMethod1"
                 :loading="loading">
                 <el-option
                   v-for="item in manufactorList"
                   :key="item.manufactor_id"
                   :label="item.manufactor_name"
                   :value="item">
                 </el-option>
               </el-select>
           </el-form-item>
           <el-form-item label="合约标题">
             <el-input v-model="form.title"   placeholder="请输入合约标题"></el-input>
           </el-form-item>
          <el-form-item label="绑定对应商品">

            <div class="goods" v-if="form.goods_info!=undefined && form.goods_info!=''" style="width:400px">
              <div class="goods-thumbnail">
                <img :src="form.goods_info.pics" alt="" style="width: 100px">
              </div>
              <div class="goods-caption">
                <div class="goods-title">
                  {{form.goods_info.itemName}}
                  <span style="color:red"  v-if="form.goods_info.special_type == 'drug'" >处方药</span>
                  <span style="color:blue" v-else>非处方药</span>
                  <span class="goods-remove iconfont icon-trash-alt" @click="handleSkuRemove()"></span>
                </div>
              </div>
            </div>
            <div v-else>
              <SkuSelector  @change="getItems" :data="relItems"></SkuSelector>
            </div>
          </el-form-item>
          <el-form-item class="content-left" label="必得优惠券">
            <el-select v-model="coupon_title" @change="changeCard()" placeholder="请选择优惠券" filterable >
              <el-option :label="v.title" :value="v.card_id" v-for="(v,i) in cardList" :key="v.card_id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.is_must!=1" class="content-left" label="支持多选">
             <el-radio-group v-model="form.is_check" size="mini">
               <el-radio :label="0" border>否</el-radio>
               <el-radio :label="1" border>是</el-radio>
             </el-radio-group>
          </el-form-item>
          <el-form-item label="选择合约" >
            <el-select
                v-model="form.long_ids"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in longList"
                  :key="item.goods_id"
                  :label="item.title"
                  :value="item.goods_id">
                </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="content-center">
             <el-button type="primary" @click="onSubmit">确定保存</el-button>
           </el-form-item>
        </el-form>
       </template>
     </el-dialog>
     <el-dialog  :visible.sync="goodsDialog.goodsVisible" :before-close="handleGoodsDialogCancel">
         <el-row :gutter="10" v-loading="goodsDialog.dialogLoading">
             <el-col :md="23">
                 <el-table ref="multipleTable" :data="goodsList" style="width: 100%" tooltip-effect="dark">
                     <!--<el-table-column type="selection" width="55" > </el-table-column>-->
                     <el-table-column prop="item_id" label="商品id" v-if="false"></el-table-column>
                     <el-table-column prop="item_name" label="商品名称" width="100">
                         <template slot-scope="scope">
                             <router-link :to="{ path: matchInternalRoute('goodsphysical_editor')+ '/' + scope.row.item_id}" class="btn-gap">{{scope.row.item_name}}</router-link>
                         </template>
                     </el-table-column>
                     <el-table-column prop="item_bn" label="商品编号">
                         <template slot-scope="scope" style="white-space: nowrap"><div v-show="false">商品id:{{scope.row.item_id}}</div>{{scope.row.item_bn}}</template>
                     </el-table-column>

                     <el-table-column prop="brief" label="商品简介" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="price" label="销售价格"></el-table-column>
                     <el-table-column prop="market_price" label="市场价格"></el-table-column>
                     <el-table-column prop="is_record" label="商品图片" width="90" >
                         <template slot-scope="scope">
                             <el-popover
                                     placement="right"
                                     width="240"
                                     trigger="hover" >
                                 <div style="overflow-y: scroll;overflow-x: hidden;height:240px;text-align:center;">
                                     <img  :src="v" class="goods-popover-img" style="width:92%;" v-for="v in scope.row.pics">
                                 </div>
                                 <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                             </el-popover>
                         </template>
                     </el-table-column>

                 </el-table>
                </el-col>
              </el-row>
     </el-dialog>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import SkuSelector from '@/components/function/skuSelector'
import { getCardList} from '@/api/cardticket'
import { deleteGoods,getCategoryList,getGoodsList,changeStatus,addManufactor,getManufactorList,deleteManufactor} from '@/api/long'

export default {
  props: {
    isLoad: {
      type: Boolean,
      default: true
    },
  },
  provide() {
    return {
      refresh: this.getList
    }
  },
  data () {
    return {
      goods_id:'',
      loading: false,
      loadingList:false,
      memberTagDialog:false,
      longList:[],
      dataList: [],
      pagers:{
        total: 0
      },
      title:"",
      coupon_title:"",
      category:[],
      pageSize:20,
      currentPage:1,
      goodsList:[],
      cardList:[],
      manufactorList:[],
      dialogLoading:false,
      params: {},
      goodsDialog:{
          dialogLoading:true,
          goodsVisible:false,
      },
      form:{
        title: '',
        is_must:0,
        is_check:0,
        goods_info: [],
      },
      relItems: [],
      fetchParams:{}
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  components: {
      SkuSelector,
  },
  watch:{
    $route(to,from){
      this.getList()
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    getCard(){

      getCardList({receive:false,is_long:1,page:1,page_size:10000}).then(res=>{
        if(res.data){
          this.cardList = res.data.data.list
        }
      })
    },
    changeCard(){
      var card = this.coupon_title
      var i=this.cardList.map((item) => item.card_id).indexOf(card);
      this.form.must_coupon=this.cardList[i];
    },
    remoteMethod1(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 新增
    add(){
      this.memberTagDialog = true
    },
    handleCancelLabelsDialog () {
      this.memberTagDialog = false
    },
    handleSkuRemove(){
      this.form.goods_info='';
    },
    getItems(data) {

      if(data.length>1){
        this.form.goods_info= data.slice(0,1)[0]
      }else{
        this.form.goods_info= data[0]
      }
    },

    onSubmit() {

      if(this.form.goods_info == ''){
        this.$message.error('商品不能为空!')
        return false
      }
      addManufactor(this.form).then(res=>{
        if(res.data.data.status){
          this.loading = false
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 2000
          })
          this.memberTagDialog = false
          this.getList()
        } else {
            this.$message.error('保存失败!')
            return false
        }
      })

    },

    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },
    titleSearch(){
      this.fetchParams.title = this.title
      this.params.page = 1
      this.getList()
    } ,
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    typeSelectHandle(){
      this.fetchParams.type = this.type
      this.params.page = 1
      this.getList()
    },
    dateChange (val) {
      if(val) {
        if (val.length > 0) {
          this.fetchParams.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.fetchParams.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.fetchParams.begin_time = ''
          this.fetchParams.end_time = ''
        }
      }else{
        this.fetchParams.begin_time = ''
        this.fetchParams.end_time = ''
      }
      this.params.page = 1
      this.getList()
    },
    del (id) {
      var that=this
      this.$confirm('确定要删除该商品？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            deleteManufactor(id).then( res => {
              if(res.status){
                this.$message({
                  message: '已删除',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(function (){
                  that.dataList.splice(index, 1)
                },1000)

              }

            })
          }
          done()
        }
      })
    },
    getList () {
      this. loadingList = true
      getManufactorList().then(res => {
        this.manufactorList = res.data.data.manufactorList
        if(res.data.data.list.length > 0) {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loadingList = false
        } else {
          this.dataList = []
          this.loadingList = false
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    search () {
      this.fetchParams.category_id = this.category_id
      this.getList()
    },
    handleGoodsDialogCancel(){
        this.goodsDialog.goodsVisible = false
    },
    async handleDialogGoods(goods_info) {
        this.goodsDialog.goodsVisible = true
        this.goodsDialog.dialogLoading = false
        this.goodsList[0] = JSON.parse(goods_info)
    },
  },
  mounted () {
    getGoodsList({is_manufactor:1}).then(res => {
       this.longList=res.data.data.list
    })
    this.getCard();
    this.getList()
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// manufactor.vue?4518a3ac